<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.isOnsale" @tab-click="handleFilter">
          <el-tab-pane label="未审核" name="0" />
          <el-tab-pane label="审核通过" name="1" />
          <el-tab-pane label="审核未通过" name="2" />
          <el-tab-pane label="删除中" name="3" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.goodsName" class="filter-item" placeholder="商品名称" clearable />
          </el-col>
          <el-col :xs="24" :sm="3">
            <el-select v-model="queryParams.supplierId" class="filter-item" placeholder="供应商" clearable>
              <el-option v-for="(item, index) in supplierList" :key="index" :value="item.id" :label="item.supplierName" />
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="9">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="供应商" prop="supplierName" min-width="150" class-name="name-col" />
        <el-table-column label="商品名称" prop="goodsName" min-width="150" class-name="name-col" />
        <el-table-column label="商品图片" prop="cover" width="100" class-name="image-col">
          <template slot-scope="{row}">
            <el-image :src="row.cover" :preview-src-list="[row.cover]" lazy />
          </template>
        </el-table-column>
        <el-table-column label="供货价" prop="stockPrice" width="90" align="right">
          <template slot-scope="{row}">{{ row.stockPrice | filterPrice }}</template>
        </el-table-column>
        <el-table-column label="建议售价" prop="retailPrice" width="80" align="right">
          <template slot-scope="{row}">{{ row.retailPrice | filterPrice }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === 3" type="info" effect="dark">删除中</el-tag>
            <el-tag v-else-if="row.status === 2" type="danger" effect="dark">未通过</el-tag>
            <el-tag v-else-if="row.status === 1" effect="dark">已通过</el-tag>
            <el-tag v-else type="info" effect="plain">未审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="row.status !== 0" @click.native="handleApprove(row.id)"><i class="el-icon-check" /> 审核</el-dropdown-item>
                <el-dropdown-item :disabled="row.status > 1" divided @click.native="handleOnsale(row.id)"><i class="el-icon-upload2" /> 上架</el-dropdown-item>
                <el-dropdown-item :disabled="row.status !== 3" divided @click.native="handleRemove(row.id)"><i class="el-icon-delete" /> 确认删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <el-dialog
      v-loading="approveLoading"
      :title="dialogTitle"
      width="80%"
      top="5vh"
      custom-class="dialog-scrollbar"
      :visible.sync="dialogVisible"
      :fullscreen="device==='mobile'"
    >
      <good-detail :detail="detail" />
      <template v-slot:footer>
        <el-button style="margin-right:10px" @click="dialogVisible = false">取 消</el-button>
        <div v-if="isApprove">
          <el-popover v-model="approveVisible" title="审核不通过" placement="top" @hide="approveMessage = ''">
            <p><el-input v-model="approveMessage" placeholder="请输入不通过的理由" clearable /></p>
            <div class="flex align-center just-end">
              <el-button type="text" size="medium" @click="approveVisible = false">取消</el-button>
              <el-button type="primary" @click="onApproved(2)">确定</el-button>
            </div>
            <el-button slot="reference" type="info">不通过</el-button>
          </el-popover>
          <el-button type="primary" style="margin-left:10px" @click="onApproved(1)">审核通过</el-button>
        </div>
        <el-popover v-else v-model="onsaleVisible" title="选择上架位置" placement="top" @hide="malls = []">
          <el-checkbox-group v-model="malls" class="el-checkbox-group-column padding-wrapper margin-wrapper">
            <el-checkbox v-for="item in mallList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
          <div class="flex align-center just-end">
            <el-button type="text" size="medium" @click="onsaleVisible = false">取消</el-button>
            <el-button type="primary" @click="onSale">确定</el-button>
          </div>
          <el-button slot="reference" type="primary">商品上架</el-button>
        </el-popover>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsList, getGoodsDetail, removeGoods, approveGoods, putGoodOnsale } from '@/api/supplier'
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'
import GoodDetail from './detail'
import { mapState } from 'vuex'

export default {
  name: 'SupplierGoodList',
  components: { Pagination, GoodDetail },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        supplierId: '',
        goodsName: '',
        isOnsale: '0',
        page: 1,
        limit: 20
      },
      isApprove: true,
      detail: null,
      dialogTitle: '商品审核',
      dialogVisible: false,
      approveVisible: false,
      approveMessage: '',
      approveLoading: false,
      onsaleVisible: false,
      mallList: [
        { id: 72000, name: '特权礼包' },
        { id: 73000, name: '积分商城' },
        { id: 75000, name: '优品商城' },
        { id: 76000, name: '福利商城' }
      ],
      malls: []
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      supplierList: state => state.base.supplierList
    })
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getGoodsList(this.queryParams).then(response => {
        this.total = response.total
        this.$util.delay().then(() => {
          this.list = response.records
          this.loading = false
        })
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    },
    handleApprove(goodsId) {
      getGoodsDetail(goodsId).then(response => {
        this.isApprove = true
        this.detail = response
        this.dialogTitle = '商品审核'
        this.dialogVisible = true
      }).catch(() => {})
    },
    onApproved(status) {
      const approveData = {
        id: this.detail.id,
        isOnsale: status,
        referred: this.approveMessage
      }
      this.approveLoading = true
      approveGoods(approveData).then(response => {
        // console.log(response)
        if (response) {
          this.approveMessage = ''
          setTimeout(() => {
            const item = this.list.filter(value => value.id === this.detail.id)
            if (item && item.length) {
              item[0].reason = approveData.referred
              item[0].status = status
            }
            this.approveLoading = false
            this.dialogVisible = false
          }, 1000)
        } else {
          this.$message.error('提交审核数据失败')
          this.approveLoading = false
        }
      }).catch(() => {
        this.approveLoading = false
      }).finally(() => {
        this.approveVisible = false
      })
    },
    handleOnsale(goodsId) {
      getGoodsDetail(goodsId).then(response => {
        this.isApprove = false
        this.detail = response
        this.dialogTitle = '商品上架'
        this.dialogVisible = true
      }).catch(() => {})
    },
    onSale() {
      if (this.malls && this.malls.length) {
        const data = {
          id: this.detail.id,
          referred: this.malls.toString()
        }
        this.approveLoading = true
        putGoodOnsale(data).then(response => {
          // console.log(response)
          if (response) {
            setTimeout(() => {
              this.approveLoading = false
              this.dialogVisible = false
            }, 1000)
          } else {
            this.$message.error('商品上架失败')
            this.approveLoading = false
          }
        }).catch(() => {
          this.approveLoading = false
        }).finally(() => {
          this.onsaleVisible = false
        })
      } else {
        this.$message.warning('请选择需要上架的位置')
      }
    },
    handleRemove(goodsId) {
      this.loading = true
      const params = Object.assign(this.queryParams, { id: goodsId })
      removeGoods(params).then(response => {
        setTimeout(() => {
          this.list = response.records
          this.total = response.total
          this.loading = false
        }, 1000)
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
  .el-checkbox-group {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
  }
}
</style>
